import { configureStore } from "@reduxjs/toolkit";
import tutorialReducer from "./tutorialSlice";
import wizardReducer from "./wizardSlice";
import filterReducer from "./filterSlice";
import { persistFilterState } from "./middleware/persistFilterState";
import practiceReducer from "./practice/practiceSlice";
import geoReducer from "./geo/geoSlice";
import sessionReducer from './sessionSlice';

const store = configureStore({
  reducer: {
    tutorial: tutorialReducer,
    wizard: wizardReducer,
    filter: filterReducer,
    practice: practiceReducer,
    geo: geoReducer,
    userSession: sessionReducer
  },
  middleware: (defaultMiddleware) =>
    defaultMiddleware().concat(persistFilterState),
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
